var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var RegistryPointService = /** @class */ (function (_super) {
    __extends(RegistryPointService, _super);
    function RegistryPointService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        return _this;
    }
    RegistryPointService.prototype.getStage = function () {
        this.baseUrl = '/v1/gen/stage-m-service?query={"predicateList":[],"orderByList":[{"name":"level","direction":"asc"}]}';
        return _super.prototype.getRecord.call(this).pipe(map(function (data) {
            return data.items;
        }));
    };
    RegistryPointService.prototype.checkItem = function (rec) {
        var items = rec['items'] || [];
        var check = true;
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            if (!this.colservice.checkVal(item.point)) {
                check = false;
            }
        }
        return check;
    };
    RegistryPointService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    RegistryPointService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return RegistryPointService;
}(ContentBaseService));
export { RegistryPointService };
var RegistryCond = /** @class */ (function () {
    function RegistryCond() {
        this.actionPointM = [];
        this.is_common = true;
    }
    return RegistryCond;
}());
export { RegistryCond };
var ActionPoint = /** @class */ (function () {
    function ActionPoint() {
        this.$type = "post" /* Post */;
    }
    return ActionPoint;
}());
export { ActionPoint };
var Behavior = /** @class */ (function () {
    function Behavior() {
    }
    return Behavior;
}());
export { Behavior };
var Stage = /** @class */ (function () {
    function Stage() {
    }
    return Stage;
}());
export { Stage };
//# sourceMappingURL=registry-point.service.js.map